import React, {useCallback, useEffect, useState} from 'react';
import request from "../../util/SuperagentUtils";
import '../../css/views/externalLanding.css'
import BlogSection from '../../components/blog/page/BlogSection';
import useDebounce from '../../hooks/useDebounce';
import {BlogPost, BlogPostsResponse} from './interfaces';
import {useSnackbar} from "../../context/snackbar-context";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../util/NetworkErrorUtil";
import {blogEndpoints} from "../../requests/api-endpoints";
import PageSEO from "../../components/seo/PageSEO";

const Blog = () => {
  const { snackbarShowMessage } = useSnackbar();
  const [search, setSearch] = useState<string>('');
  const searchDebounceVal = useDebounce(search, 600);
  const [email, setEmail] = useState<string>('');
  const [blogs, setBlogs] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const LIMIT = 9;
  const [offset, setOffset] = useState<number>(0);
  const [totalBlogs, setTotalBlogs] = useState<number>(1);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await request.get(blogEndpoints.search)
        .query({
          limit: LIMIT,
          offset: offset,
          search: searchDebounceVal
        });

      // Parse the response properly
      const responseData: BlogPostsResponse = response.body || JSON.parse(response.text || '{}');

      // Access the correct properties from the parsed data
      setBlogs(responseData?.results || []);
      setTotalBlogs(responseData?.total || 0);
    } catch (error) {
      snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error');
    } finally {
      setLoading(false);
    }
  }, [offset, searchDebounceVal, snackbarShowMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return <>
    {/* This list copies the HubSpot blog, so the original gets the credit. */}
    <PageSEO
      title="Blog | SecurSpace"
      description="Stay up to date on all things truck and trailer parking, equipment drop off, drop yard efficiency, yard space and more with the SecurSpace blog."
      canonicalUrl="https://launch.secur.space/blog"
    />
    <BlogSection
      totalPage={Math.ceil(totalBlogs / LIMIT)}
      setOffset={setOffset}
      search={search}
      setSearch={setSearch}
      email={email}
      setEmail={setEmail}
      blogs={blogs}
      loading={loading}
    />
  </>;
};

export default Blog;
